import { PageError403 } from '@/pages/Errors/403'
import { PageError500 } from '@/pages/Errors/500'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { ROUTES } from '@/utils/constants/routesConstants'
import { ProtectedRoutes } from './ProtectedRoutes'
import { setShellActive, setShellPath } from '@/store/slices/commonSlice'
import {
  SalesTargetHome,
  PageError404,
  AddSalesTarget,
  AddSalesTargetProduct,
  AddSalesTargetDisplayContent,
  PointMultiplier,
  CreateBulkPointModifiers,
  StoreName,
  ActivitiesList,
  StoreListPage,
  SalesTargetReview,
  DynamicTable,
  AddActivity,
  AddActivityReview,
  TestPage,
  BulkModifiersHome,
  StoreDetails,
  ReviewBulkPointModifiers,
  Fullfillment,
  ClubPlusHome,
  CreateTier,
  ReviewPointMultiplier,
} from '@/pages'
import { CreatePointMultiplier } from '@/pages/PointMultiplier/index'
import { useAppDispatch } from '@/store'
import { useEffect } from 'react'
import { ImageOptimization } from '@/containers/ImageOptimization'
import { useSelector } from 'react-redux'
import { UserDetails } from '@/services/UserDetails'
import { setUserDetails } from '@/store/slices/userSlice'
import { isObjectNotEmpty } from '@/helpers/shadcn/utils'
import { useGrowthBookFeatureFlags } from '@/hooks/use-growthbook-feature-flags-hook'
import { GrowthBookProvider } from '@growthbook/growthbook-react'
import { setCountryCode } from '@/store/slices/countryCodeSlice'
import { ProductsPointMultiplier } from '@/pages/PointMultiplier/index'

const productRoutes = [
  { path: ROUTES.PRODUCT_FULLFILLMENT, element: <Fullfillment /> },
]

const clubPlusRoutes = [
  { path: ROUTES.CLUB_HOME, element: <ClubPlusHome /> },
  { path: ROUTES.CREATE_TIER, element: <CreateTier /> },
]

const router = createBrowserRouter([
  {
    element: <ProtectedRoutes />,
    children: [
      { path: ROUTES.HOME, element: <SalesTargetHome selectedTab="activities" /> },

      { path: ROUTES.SALES_TARGETS, element: <SalesTargetHome selectedTab="sales-target" /> },
      { path: ROUTES.SALES_TARGET_ADD, element: <AddSalesTarget /> },
      { path: ROUTES.SALES_TARGET_DISPLAY_CONTENT, element: <AddSalesTargetDisplayContent /> },
      { path: ROUTES.SALES_TARGET_PRODUCTS, element: <AddSalesTargetProduct /> },
      { path: ROUTES.SALES_TARGET_REVIEW, element: <SalesTargetReview /> },
      { path: ROUTES.SALES_TARGET_DETAIL, element: <SalesTargetReview /> },

      { path: ROUTES.ACTIVITIES, element: <SalesTargetHome selectedTab="activities" /> },
      { path: ROUTES.ACTIVITY_ADD, element: <AddActivity /> },
      { path: ROUTES.ACTIVITY_REVIEW, element: <AddActivityReview /> },

      { path: ROUTES.POINT_MULTIPLIER, element: <PointMultiplier /> },
      { path: ROUTES.POINT_MULTIPLIER_CREATE, element: <CreatePointMultiplier /> },
      { path: ROUTES.POINT_MULTIPLIER_REVIEW, element: <ReviewPointMultiplier /> },
      { path: ROUTES.POINT_MULTIPLIER_VIEW, element: <ReviewPointMultiplier /> },
      { path: ROUTES.POINT_MULTIPLIER_PRODUCTS, element: <ProductsPointMultiplier /> },

      { path: ROUTES.BULK_POINT_MODIFIERS, element: <BulkModifiersHome /> },
      { path: ROUTES.BULK_POINT_MODIFIER_CREATE, element: <CreateBulkPointModifiers /> },
      { path: ROUTES.BULK_POINT_MODIFIER_REVIEW, element: <ReviewBulkPointModifiers /> },

      { path: ROUTES.STORE_NAME, element: <StoreName /> },
      { path: ROUTES.ACTIVITY_ADD, element: <AddActivity /> },
      { path: ROUTES.ACTIVITY_REVIEW, element: <AddActivityReview /> },
      {path: ROUTES.ACTIVITY_VIEW, element: <AddActivityReview />},
      { path: ROUTES.ACTIVITIES, element: <ActivitiesList /> },
      { path: ROUTES.STORE_LIST, element: <StoreListPage /> },
      { path: ROUTES.TABLE, element: <DynamicTable /> },
      { path: ROUTES.STORE_DETAILS, element: <StoreDetails /> },

      { path: ROUTES.TABLE, element: <DynamicTable /> },
      { path: ROUTES.IMAGE, element: <ImageOptimization /> },
      { path: ROUTES.FULLFILLMENT, element: <Fullfillment /> },
      { path: ROUTES.ADD_SALES_TARGET_DETAIL, element: <SalesTargetReview /> },
      { path: ROUTES.PRODUCTS_POINT_MULTIPLIER,element: <ProductsPointMultiplier/>},
      /* Errors */
      { path: ROUTES.ERROR_500, element: <PageError500 /> },
      { path: ROUTES.ERROR_403, element: <PageError403 /> },
      { path: '*', element: <PageError404 /> },

      { path: ROUTES.TEST, element: <TestPage /> },
      /* Products */
      ...productRoutes,
      ...clubPlusRoutes,
    ],
  },
])

export const AppRouter = ({ shellActive, darkTheme, path, market }) => {

  const dispatch = useAppDispatch()
  const { growthbook } = useGrowthBookFeatureFlags()

  const userData = useSelector(state => state?.userDetails)
  const getUserData = async () => {
    if (!isObjectNotEmpty(userData)) {
      try {
        await UserDetails()
        const reqData = {
          name: 'Robert',
          role: ['admin', 'super-admin'],
          country: [{ name: 'Mexico', lang: [{ langcode: 33, name: 'mexico' }] }],
          countryCode: 'mx',
          siteId: 21,
        }
        dispatch(setUserDetails(reqData))
      } catch {
        const reqData = {
          name: 'Louis',
          role: ['admin'],
          country: [{ name: 'Turkey', lang: [{ langcode: 31, name: 'Turkey' }] }],
          countryCode: 'TR',
          siteId: 23,
        }
        dispatch(setUserDetails(reqData))
      }
    }
  }
  useEffect(() => {
    getUserData()
  })
  useEffect(() => {
    dispatch(setShellActive(shellActive))
    if (market) {
      dispatch(setCountryCode(market))
    }
  }, [shellActive, dispatch, market])

  useEffect(() => { }, [darkTheme])

  // expected everytime to dispatch the shell path when component is mounted to navigate properly
  useEffect(() => {
    dispatch(setShellPath(path))
  })

  return (
    <GrowthBookProvider growthbook={growthbook}>
      <RouterProvider router={router} />
    </GrowthBookProvider>
  )
}
